<template>
  <div>
    <qx-card title="被邀请" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100011"
      :customPost="true"
      @sub="sub"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  driverArchivesInvitedDetail, // 获取详情
  driverArchivesInvitedApprove, // 审核
} from 'api/archives';
import {
  getFileUrl,
} from 'api';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'mobilePhone',
                label: '司机账号',
              },
              {
                prop: 'applyCarUserTypeName',
                label: '司机类型',
              },
              {
                prop: 'userPriceUrl',
                label: '司机头像',
                type: 'img',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        car: {
          label: '发起邀请的车队',
          tableData: {
            title: [
              {
                prop: 'tenantName',
                label: '车队名称',
              },
              {
                prop: 'tennantLinkPhone',
                label: '联系电话',
              },
              {
                prop: 'applyCarUserTypeName',
                label: '申请类型',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        apply: {
          label: '申请转移自有车司机',
          tableData: {
            title: [
              {
                prop: 'applyRemark',
                label: '申请说明',
              },
              {
                prop: 'applyFileUrl',
                label: '附件',
                type: 'img',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  // watch: {
  //   '$route.query.id': function () {
  //     this.getData();
  //   },
  // },
  methods: {
    async getData () {
      this.loading = true;
      const detailRes = await driverArchivesInvitedDetail({
        applyId: this.id || this.$route.query.id,
      });
      this.loading = false;
      // detailRes. = 68252965931008;
      if (!detailRes.failed) {
        // 图片处理
        let ids = [];
        if (detailRes.userPrice) {
          ids.push(detailRes.userPrice);
        }
        if (detailRes.applyFile) {
          ids.push(detailRes.applyFile);
        }
        if (ids.length !== 0) {
          const imgs = await getFileUrl({
            flowIds: ids.join(','),
            _GRID_TYPE: 'jq',
          });
          imgs.rows.forEach((item) => {
            if (item.flowId === detailRes.userPrice) {
              detailRes.userPriceUrl = item.fullPath;
            }
            if (item.flowId === detailRes.applyFile) {
              detailRes.applyFileUrl = item.fullPath;
            }
          });
        }
        // 图片处理 end
        this.detailData.base.tableData.data = detailRes;
        this.detailData.car.tableData.data = detailRes;
        this.detailData.apply.tableData.data = detailRes;
        // if (this.$route.query.type) {
        //   this.detailData.base.tableData.approveData = detailRes.ver;
        //   this.detailData.settlement.tableData.approveData = detailRes.ver;
        // }
      }
    },
    async sub (formData) {
      const confirmRes = await this.$confirm(`确认将该${this.detailData.car.tableData.data.applyCarUserTypeName}账号转移？转移后您将无法使用该司机账户，可在是历史档案中查询到。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消
        this.$message({
          type: 'info',
          message: '已取消切换',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await driverArchivesInvitedApprove({
          busiId: this.$route.query.id,
          busiCode: 100011,
          oldUserId: this.detailData.base.tableData.data.userId,
          chooseResult: formData.chooseResult,
          desc: formData.desc,
          // plateNumbers:
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
